var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPokerSeats2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 3,
    width: 14,
    height: 10,
    rx: 5,
    fill: "#D70A0A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.46 10.563v.937H5.696v-.806L8.01 8.17c.254-.287.454-.534.6-.742.147-.209.25-.396.308-.562.062-.17.093-.333.093-.493 0-.225-.043-.421-.127-.59a.929.929 0 00-.362-.406c-.159-.101-.353-.151-.58-.151-.264 0-.486.057-.665.17a1.068 1.068 0 00-.405.474 1.622 1.622 0 00-.137.684H5.56c0-.414.094-.791.283-1.133.189-.345.462-.619.82-.82.358-.205.79-.308 1.294-.308.475 0 .879.08 1.211.24.332.159.584.385.757.678.176.293.264.64.264 1.04 0 .221-.036.441-.108.66a3.12 3.12 0 01-.308.653c-.13.215-.284.432-.463.65-.18.215-.376.433-.591.654L7.18 10.562h3.28z",
    fill: "#fff"
  })));
}
SvgPokerSeats2.displayName = 'PokerSeats2';
export default SvgPokerSeats2;